import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";
import { Flame, Clock } from "lucide-react";

export default function FestivalCountdown() {
  const [festivals, setFestivals] = useState([]);
  useEffect(() => { api.get("/festivals/upcoming").then((r) => setFestivals(r.data.items)).catch(() => {}); }, []);

  if (!festivals.length) return null;
  const main = festivals[0];

  return (
    <section data-testid="festival-countdown" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
      <div className="relative bg-[#4A0E17] rounded-3xl overflow-hidden text-[#FAF6F0]">
        <div className="absolute -right-6 -top-10 font-devanagari text-[280px] leading-none text-[#D4AF37] opacity-10 pointer-events-none select-none">ॐ</div>
        <div className="relative grid lg:grid-cols-2 gap-8 p-8 lg:p-12 items-center">
          <div>
            <div className="overline text-[#D4AF37]">Upcoming Festival</div>
            <h2 className="font-serif text-4xl lg:text-5xl mt-3 leading-tight">{main.title}</h2>
            <p className="text-[#FAF6F0]/80 mt-4 leading-relaxed">{main.significance}</p>
            <div className="mt-6 inline-flex items-center gap-3 bg-[#D4AF37]/15 border border-[#D4AF37]/40 rounded-full px-5 py-2.5">
              <Clock className="w-4 h-4 text-[#D4AF37]" />
              <span className="font-mono text-[#F3E5AB]">
                {main.days_away === 0 ? "Today" : main.days_away === 1 ? "Tomorrow" : `${main.days_away} days away`} · {main.date}
              </span>
            </div>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link data-testid="festival-donate-cta" to="/donate" className="btn-saffron">Offer a festival seva</Link>
              <Link to="/seva-club" className="btn-ghost-gold !text-[#F3E5AB] !border-[#D4AF37] hover:!bg-[#D4AF37]/15">Join Blessing Club</Link>
              <Link to="/festivals" data-testid="festival-calendar-cta" className="btn-ghost-gold !text-[#F3E5AB] !border-[#D4AF37] hover:!bg-[#D4AF37]/15">Full festival calendar</Link>
            </div>
          </div>
          <div className="space-y-3">
            <div className="overline text-[#D4AF37]">Also coming up</div>
            {festivals.slice(1).map((f, i) => (
              <div key={i} data-testid={`upcoming-${i}`} className="flex items-start gap-4 p-4 rounded-xl bg-white/5 border border-[#D4AF37]/20">
                <Flame className="w-5 h-5 text-[#E65100] shrink-0 mt-1" />
                <div className="flex-1">
                  <div className="font-serif text-xl">{f.title}</div>
                  <div className="text-sm text-[#FAF6F0]/70">{f.significance}</div>
                </div>
                <div className="text-xs font-mono text-[#D4AF37] text-right whitespace-nowrap">
                  <div>{f.date}</div>
                  <div className="opacity-80">in {f.days_away}d</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
